import { Select } from "#components/molecules/Select/Select";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { MaterialChangeDisclaimerModal } from "#modules/quoteRequestLines/MaterialChangeDisclaimerModal";
import { useMaterialSelect } from "#modules/quoteRequestLinesV2/hooks/useMaterialSelect";
import { AssemblyWithChildren, MaterialGradeType } from "shared";

type MaterialSelectValue = {
  materialName: string;
  materialGrade: MaterialGradeType | null;
};

type Props = {
  onChange: (materialName: string, materialGrade: MaterialGradeType | null) => void;
  disabled?: boolean;
  assembly?: AssemblyWithChildren<QuoteRequestLineDto>;
  quoteRequestLine?: QuoteRequestLineDto;
  value?: MaterialSelectValue | null;
  placeholder?: string;
  ariaLabel?: string;
};

export const MaterialSelect = ({
  onChange,
  disabled,
  assembly,
  quoteRequestLine,
  value,
  placeholder,
  ariaLabel,
}: Props) => {
  const {
    displayValue,
    materialOptions,
    onSelectChange,
    modalOpened,
    onModalClose,
    onModalConfirm,
    checkboxProps,
  } = useMaterialSelect({ onChange, assembly, quoteRequestLine, value });

  return (
    <>
      <Select
        disabled={disabled}
        value={displayValue}
        onChange={onSelectChange}
        placeholder={placeholder}
        aria-label={ariaLabel}
        data={materialOptions}
        searchable
      />

      <MaterialChangeDisclaimerModal
        opened={modalOpened}
        onClose={onModalClose}
        onConfirm={onModalConfirm}
        checkboxProps={checkboxProps}
      />
    </>
  );
};
